module.exports = __webpack_public_path__ + "img/sort-down__active.311f1440.png";